// The browser's built-in PDF viewer (Chrome/Edge) reads PDF Open Parameters
// off the URL fragment - safe to append after a presigned S3 URL's query
// string since fragments never get sent to the server. Used to control the
// initial view without any extra dependency.

// Uploaded PDF attachments, in the modal's single-page zoomed view: start
// noticeably more zoomed in than the viewer's own default, so the page is
// readable without the user having to click the zoom-in control themselves.
export function toZoomedPdfUrl(url: string): string {
  return `${url}#zoom=110`;
}

// Chart screenshots (main + zoomed-in) are wide/landscape but exported onto
// a tall page with a lot of blank space below the chart. Fit-to-width keeps
// the whole chart visible with no side-to-side cropping regardless of
// exactly how tall that blank area is, instead of guessing a zoom percent.
export function toZoomedChartUrl(url: string): string {
  return `${url}#view=FitH`;
}

// Fit-to-width for any small, non-interactive thumbnail card (chart
// screenshots on the report page, PDF pages in the per-document grid) so the
// whole page width shows instead of just its top-left corner at the
// viewer's default zoom. Toolbar hidden since nothing here is interactive.
export function toFitWidthThumbnailUrl(url: string): string {
  return `${url}#view=FitH&toolbar=0`;
}
